import React from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import Icon, { IconType } from '../icon/icon';
import './menuItem.scss';
import PermissionGate from '../permissionsGate/permissionsGate';

const MenuItem = (props) => {
  const {
    children, to, disabled, icon, onClick, id, className, scopes,type,menuId,parentId,
  } = props;
  const fontColor = process.env.REACT_APP_MENU_FONT_COLOR;
  const handlerMenuClick=(e)=>{
    if (e.currentTarget.classList.contains("submenu-toggle")) {
          const menuId = e.currentTarget.dataset.id;
          const collapsed = e.currentTarget.getAttribute("data-collapsed");
          if(collapsed=="false" || collapsed==null){
              e.currentTarget.setAttribute("data-collapsed","true");
              e.currentTarget.querySelector(".nav-link div").textContent =menuId ? menuId+'▸' : '▸';
              collapseMenu(menuId);
          }else{
              e.currentTarget.setAttribute("data-collapsed","false");
              e.currentTarget.querySelector(".nav-link div").textContent =menuId ? menuId+'▾' : '▾';
              expandMenu(menuId);
          }  
      }
  }
  const collapseMenu=(menuId)=>{
    document.querySelectorAll(`.nav-item[data-parentid='${menuId}']`).forEach(sm => sm.style.display = 'none');
  }
  const expandMenu=(menuId)=>{
    document.querySelectorAll(`.nav-item[data-parentid='${menuId}']`).forEach(sm => sm.style.display = 'block');
  }
  const defaultResponse = 
    <li className={`nav-item ${className}`} data-id={menuId} data-parentid={parentId} data-collapsed="false"
      onClick={(e) => {handlerMenuClick(e);}}
    > 
      {to && <NavLink id={id} name={id} onClick={onClick} className={`nav-link ${disabled ? 'disabled' : ''} ${type=="submenu" ? 'submenu' : ''}`} style={{color:fontColor}} to={to}>
        { icon !== ''
          && (
            <Icon 
              iconColor={"#"+fontColor}
              icon={icon}
            />
          )}
          <div style={{color:"#"+fontColor}} >
            {children}
          </div>
      </NavLink>}
      {!to && <div id={id} name={id} onClick={onClick} className={`nav-link ${disabled ? 'disabled' : ''}`} style={{color:fontColor}}>
        { icon !== ''
          && (
            <Icon 
              iconColor={"#"+fontColor}
              icon={icon}
            />
          )}
          <div style={{color:"#"+fontColor}} >
            {children+menuId ? menuId+'▾' : ''}
          </div>
      </div>}
    </li>


//  document.querySelectorAll('.submenu-toggle').forEach(toggle => {
    
//       toggle.addEventListener('click', (e) => {
//         console.log("clicked");
//       const menuId = e.currentTarget.dataset.id;  // get data-id of clicked toggle
//       const submenu = toggle.nextElementSibling;
//       const isVisible = submenu.style.display === 'block';

//       // toggle arrow
//       toggle.querySelector(".nav-link div").textContent = isVisible ? (menuId ? menuId+'▸' : '▸') : (menuId ? menuId+'▾' : '▾');
//       // toggle.textContent = isVisible ? 'Youtube ▸' : 'Youtube ▾';
//       document.querySelectorAll('.submenu').forEach(sm => sm.style.display = 'none');
//       submenu.style.display = isVisible ? 'none' : 'block';

//     });
  // });
  return (
    <>
      {scopes.length > 0 &&
        <PermissionGate scopes={scopes}>
            {defaultResponse}
        </PermissionGate>
      }
      {scopes.length == 0 &&
          defaultResponse
      }
    </>
  );
};

MenuItem.propTypes = {
  children: PropTypes.node.isRequired,
  to: PropTypes.string,
  disabled: PropTypes.bool,
  icon: PropTypes.oneOf(Object.values(IconType)),
  onClick: PropTypes.func,
  className: PropTypes.string,
  scopes: PropTypes.arrayOf(PropTypes.string),
};

MenuItem.defaultProps = {
  to: '',
  disabled: false,
  icon: '',
  onClick: () => {},
  className: '',
  scopes: [],
};

export default MenuItem;
